"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _IconSVG = _interopRequireDefault(require("../components/IconSVG"));
var _excluded = ["size", "title", "ariaHidden"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var pathSizesToPaths = {
  "16": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M1.1 8a6.894 6.894 0 0 1 6.887-6.886c3.796 0 6.884 3.09 6.884 6.886a6.893 6.893 0 0 1-6.884 6.885A6.893 6.893 0 0 1 1.1 8Zm-1 0c0 4.348 3.539 7.885 7.887 7.885 4.348 0 7.884-3.537 7.884-7.885S12.334.114 7.987.114C3.639.114.1 3.652.1 8Zm5.507 3.469.603.798 5.192-3.921a.5.5 0 0 0-.005-.802L6.205 3.73l-.592.806 4.65 3.417-4.656 3.516Z"
  }),
  "24": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M1.594 12C1.594 6.262 6.262 1.594 12 1.594S22.406 6.262 22.406 12 17.738 22.406 12 22.406 1.594 17.738 1.594 12ZM.469 12c0 6.358 5.173 11.531 11.531 11.531 6.359 0 11.531-5.172 11.531-11.531 0-6.359-5.172-11.531-11.53-11.531C5.64.469.468 5.64.468 12Zm8.106 5.295.678.898 7.71-5.823a.561.561 0 0 0-.005-.902l-7.71-5.666-.667.907 7.103 5.219-7.109 5.367Z"
  }),
  "32": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M2.125 16C2.125 8.349 8.35 2.125 16 2.125S29.875 8.349 29.875 16 23.651 29.875 16 29.875C8.35 29.875 2.125 23.651 2.125 16Zm-1.5 0c0 8.478 6.897 15.375 15.375 15.375S31.375 24.478 31.375 16 24.478.625 16 .625.625 7.522.625 16Zm10.809 7.06.904 1.197 10.28-7.764a.748.748 0 0 0-.008-1.203L12.33 7.736l-.889 1.21 9.47 6.957-9.478 7.157Z"
  }),
  "48": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M2.828 23.984c0 11.674 9.498 21.172 21.172 21.172 11.674 0 21.172-9.498 21.172-21.172C45.172 12.31 35.674 2.812 24 2.812c-11.674 0-21.172 9.498-21.172 21.172Zm-1.875 0C.953 11.276 11.292.937 24 .937s23.047 10.34 23.047 23.047c0 12.708-10.34 23.047-23.047 23.047C11.292 47.031.953 36.692.953 23.984Zm17.381-12.333 15.543 11.42a.939.939 0 0 1 .01 1.503L18.345 36.31l-1.13-1.496 14.538-10.978-14.529-10.674 1.11-1.511Z"
  }),
  "64": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M3.77 31.979c0 15.565 12.665 28.229 28.23 28.229 15.565 0 28.229-12.664 28.229-28.229S47.565 3.75 31.999 3.75c-15.564 0-28.228 12.664-28.228 28.229Zm-2.5 0C1.27 15.035 15.057 1.25 32 1.25c16.944 0 30.729 13.785 30.729 30.729s-13.785 30.729-30.73 30.729c-16.943 0-30.728-13.785-30.728-30.729Zm23.176-16.445L45.17 30.76a1.251 1.251 0 0 1 .013 2.005L24.46 48.413l-1.507-1.995 19.384-14.637L22.966 17.55l1.48-2.015Z"
  })
};
var pathSizesToViewBox = {
  "16": "0 0 16 16",
  "24": "0 0 24 24",
  "32": "0 0 32 32",
  "48": "0 0 48 48",
  "64": "0 0 64 64"
};
var sizesToPathSizes = {
  "16": "16",
  "24": "24",
  "32": "32",
  "48": "48",
  "64": "64"
};
var sizes = ['16', '24', '32', '48', '64'];
var IconCaretCircleRight = function IconCaretCircleRight(_ref) {
  var _ref$size = _ref.size,
    sizeProp = _ref$size === void 0 ? '32' : _ref$size,
    _ref$title = _ref.title,
    title = _ref$title === void 0 ? 'Caret Circle Right' : _ref$title,
    _ref$ariaHidden = _ref.ariaHidden,
    ariaHidden = _ref$ariaHidden === void 0 ? false : _ref$ariaHidden,
    props = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var size = sizes.indexOf(sizeProp) !== -1 ? sizeProp : '32';
  return /*#__PURE__*/_react.default.createElement(_IconSVG.default, (0, _extends2.default)({
    width: size,
    height: size,
    viewBox: pathSizesToViewBox[sizesToPathSizes[size]],
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    role: "img",
    title: title,
    ariaHidden: ariaHidden
  }, props, {
    iconClass: "CaretCircleRight"
  }), pathSizesToPaths[sizesToPathSizes[size]]);
};
IconCaretCircleRight.sizes = [16, 24, 32, 48, 64];
IconCaretCircleRight.propTypes = {
  /** Available sizes: 16, 24, 32, 48, 64. In most cases, the size will be a square (e.g., 32px X 32px), but height variances can occur. */
  size: _propTypes.default.oneOf(sizes),
  /** Similar to the 'alt' attribute on image tags, this is optional for custom tooltips and will default to the icon name if not overriden. */
  title: _propTypes.default.string,
  /** Hide icon from screen readers. */
  ariaHidden: _propTypes.default.bool,
  /** Optional custom class. */
  className: _propTypes.default.string
};
var _default = IconCaretCircleRight;
exports.default = _default;